<script type="ts">
	import type { BeautifiedCode } from 'src/app';
	import { getContext } from 'svelte';
	import Partial from './Partial.svelte';

	const examples: BeautifiedCode.GroupedExamples = getContext('examples');
	export let show: string;
	export let group: string;

	function findExample(needle: string, haystack: BeautifiedCode.Example[]) {
		const example = haystack.find((example) => {
			const name = example.filename.split('.')[0];
			if (!name) {
				return false;
			}
			return name.includes(needle);
		});

		return example;
	}
	const example = findExample(group, Object.values(examples));
	const whitelist = show.split(',').map((s) => s.trim());

	if (!example) {
		throw new Error(`No example for group "${group}"`);
	}

	const partials = example.partials.filter((p) => whitelist.includes(p.name));

	if (!partials) {
		throw new Error(`No partials for show "${show}" group "${group}"`);
	}

	let activeTab: BeautifiedCode.Partial;
	let activeName: string;
	$: activeTab = partials.find((p) => p.name === activeName) || partials[0];
</script>

<div class="code-wrapper shadow-xl" class:minicode={partials.length === 1}>
	{#if activeTab}
		<div class="editor">
			{#if partials.length > 1}
			<div class="tabs">
				{#each partials as tab}
					<button
						class="tab"
						class:active={activeTab && tab.name === activeTab.name}
						on:click={() => (activeName = tab.name)}
					>
						<img class="icon" alt="JavaScript icon" src="/lang/typescript.svg" />
						{tab.name}.{example.language}
					</button>
				{/each}
			</div>
			{/if}
			<div class="code-wrapper__inner">
				<Partial data={activeTab} />
			</div>
		</div>
	{:else}
		<div class="editor">
			<div class="error">
				No partials found for show "{show}" group "{group}"
			</div>
		</div>
	{/if}
</div>

<style lang="scss">
	.error {
		padding: 20px;
	}
	.icon {
		width: 14px;
		height: 14px;
		margin-right: 0.5em;
		color: var(--color-javascript);

		opacity: 0.6;

		.active &,
		button:hover & {
			opacity: 1;
		}
	}

	.tabs {
		background-color: var(--editor-25);
		display: flex;
		gap: 20px;
		border-radius: $border_radius;
		border-bottom-left-radius: 0px;
		border-bottom-right-radius: 0px;
		overflow: hidden;
		border-bottom: 1px solid var(--editor-40);
	}

	.tab {
		cursor: pointer;
		color: white;
		font-size: 14px;
		text-align: center;

		display: flex;
		align-items: center;
		justify-content: center;

		padding: 9px 18px;
		background-color: transparent;
		border: 0;
		border-bottom: 2px solid transparent;
		margin-bottom: -2px;

		opacity: 0.75;
		position: relative;

		min-width: 150px;

		&.active {
			background-color: var(--editor-30);
			opacity: 1;
		}
		&:hover:not(.active) {
			// background-color: var(--editor-30);
			opacity: 1;
		}
	}
</style>
